export default __webpack_public_path__ + "static/media/down-arrow.8f018a67.svg";